import { render, staticRenderFns } from "./Ueditor.vue?vue&type=template&id=27d84048&"
import script from "./Ueditor.vue?vue&type=script&lang=js&"
export * from "./Ueditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports